import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpcomingClassesComponent } from './upcoming-classes.component';
import { ListComponent } from './list/list.component';
import { RescheduleComponent } from './reschedule/reschedule.component';
import { UpcomingClassesRoutingModule } from './upcoming-classes-routing.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { UpcomingComponent } from './upcoming/upcoming.component';
import { MomentModule } from 'ngx-moment';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FeatureModule } from '../../../../shared/src/lib/feature/feature.module';
import { ReschedulePendingComponent } from './reschedule-pending/reschedule-pending.component';
import { AssignSheetComponent } from './assign-sheet/assign-sheet.component';
import { SheetDetailComponent } from './sheet-detail/sheet-detail.component';
import { AssignedSheetDetailComponent } from './assign-sheet/assigned-sheet-detail/assigned-sheet-detail.component';
import { MaterialModule } from '../../../../shared/src/lib/material.module';
import { RescheduleRequestComponent } from './reschedule-request/reschedule-request.component';
import { AssignExerciceComponent } from './assign-exercice/assign-exercice.component';

@NgModule({
  imports: [
    CommonModule,
    UpcomingClassesRoutingModule,
    MomentModule,
    ReactiveFormsModule,
    MaterialModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    FeatureModule,
    TranslateModule.forChild(),
    FormsModule
  ],
  declarations: [
    UpcomingClassesComponent,
    ListComponent,
    RescheduleComponent,
    UpcomingComponent,
    ReschedulePendingComponent,
    AssignSheetComponent,
    SheetDetailComponent,
    AssignedSheetDetailComponent,
    RescheduleRequestComponent,
    AssignExerciceComponent
  ],
  exports: [
    UpcomingComponent,
    MatFormFieldModule,
    MatInputModule,
    ReschedulePendingComponent,
    AssignSheetComponent,
    RescheduleRequestComponent
  ]
})
export class UpcomingClassesModule { }
